<template>
  <div class="container">
    <div class="text1">怎样联系我们？</div>
    <img src="../assets/four-items.png" alt="" class="four-imgs">
    <div class="text2">我们在哪里？</div>
    <img src="../assets/contact-map.png" alt="" class="map">
  </div>
</template>

<script>
  export default {
    name: 'contact',
    data () {
      return {

      }
    },
  }
</script>

<style scoped>
.container{
  display: flex;
  flex-direction: column;
  align-items: center;
}
.text1{
  font-weight:bold;
  color:rgba(51,51,51,1);
  font-size:26px;
  margin-top: 128px;
}
.four-imgs{
  width: 63.54%;
  margin-top: 40px;
}
.text2{
  font-weight:bold;
  color:rgba(51,51,51,1);
  font-size:26px;
  margin-top: 79px;
}
.map{
  width: 63.54%;
  margin-top: 40px;
  margin-bottom: 78px;
}
</style>



// WEBPACK FOOTER //
// src/components/contact.vue